import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import notify from 'devextreme/ui/notify';
import { moduli } from '../../config';
import { UredjajiService } from './uredjaji.service';

@Component({
  selector: 'app-uredjaji',
  templateUrl: './uredjaji.component.html',
  styleUrls: ['./uredjaji.component.scss'],
  providers: [UredjajiService]
})
export class UredjajiComponent implements OnInit {

  idkorisnik: any = localStorage.getItem('idsecuser');;
  access_token: any = sessionStorage.getItem('token');;
  idfirma: any = localStorage.getItem('firma');;
  uredjajiPopis: any = [];
  noDataMessage = 'Učitavanje...';

  // PRAVA KORISNIKA
  pravaKorisnika = JSON.parse(sessionStorage.getItem('pravakorisnika'));
  trenutniPogled: any;
  pravaZaTrenutniPogled: any;
  prikaziStranicu = 0;
  // KRAJ PRAVA KORISNIKA

  constructor(private _service: UredjajiService, private router: Router) {
    if (parseInt(localStorage.getItem('firma')) == 3) {
      this.router.navigate(['/dostavnica-hlad']);
    }

    // PRAVA KORISNIKA
    this.trenutniPogled = moduli().uredjaji;
    for (var i = 0; i < this.pravaKorisnika.length; i++) {
      //console.log(i);
      if (this.pravaKorisnika[i].smo_ime == this.trenutniPogled) {
        this.pravaZaTrenutniPogled = this.pravaKorisnika[i].sgm_prava;
        //console.log(this.pravaZaTrenutniPogled);
        if (this.pravaKorisnika[i].sgm_prava != 0) {
          this.prikaziStranicu = 1;
        } else {
          notify('Nemate prava.', 'error', 3000);
        }
        return;
      } else {
      }
    }
    // KRAJ PRAVA KORISNIKA
  }

  popisUredjaja(){
    let podaciZaSlanje = {
      idfirma: this.idfirma,
      idkorisnik: this.idkorisnik,
      access_token: this.access_token 
    };
    //console.log(podaciZaSlanje);
    this.uredjajiPopis = [];
    this._service.dohvatiSveUredaje(podaciZaSlanje).subscribe(res=>{
      //console.log(res);
      if (res.success == true) {
       this.uredjajiPopis = res.data;
      }
    });
  }

  promjeniStatus(e: any, data: any) {
    //console.log('e:  ', e.value);
    //console.log('data: ', data);
    //console.log('data.data: ', data.data);

    let aktivan = 0;
    if (e.value == true) {
      aktivan = 1;
    }

    let podaciZaSlanje = {
      idfirma: this.idfirma,
      idkorisnik: this.idkorisnik,
      access_token: this.access_token,
      iduredjaj: data.data.id_uredjaj,
      ur_aktivan: aktivan
    }
    //console.log(podaciZaSlanje);
    this._service.urediUredjaj(podaciZaSlanje).subscribe(res=>{
      //console.log(res);
      this.popisUredjaja();
      if (res.success == true) {
        notify('Uspješno ste promijenili status...', 'success', 3000);
      }else{
        notify(res.message, 'error', 3000);
      }
    });
  }

  ngOnInit(): void {
    this.popisUredjaja();
  }

}
